module.exports = __webpack_public_path__ + "static/media/viewProfile.16c01e6e.svg";